module.exports = __webpack_public_path__ + "static/img/505.ecdaa0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/505.png
// module id = 534
// module chunks = 3